// HeatmapByDayHour.tsx
import React from 'react';
import Chart from 'react-apexcharts';

import { ITrafficHourData, ITrafficDayData } from '../../../api'

type Props = {
  data: ITrafficDayData[];
  width?: string | number;
  height?: string | number;
};

const TrafficHeatmap: React.FC<Props> = ({ data, width = '100%', height = 300 }) => {
  const dayNames = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

  const completeData = Array.from({ length: 7 }, (_, i) => {
    const day = data.find(d => d.day === i + 1);
    const hoursMap = day?.hours.reduce((acc, h) => {
      acc[h.hour] = h.value;
      return acc;
    }, {} as Record<number, number>) || {};

    const hours: ITrafficHourData[] = Array.from({ length: 24 }, (_, h) => ({
      hour: h,
      value: hoursMap[h] ?? 0
    }));

    return { day: i + 1, hours };
  });

  const series = completeData.map(day => ({
    name: dayNames[day.day - 1],
    data: day.hours.map(h => ({ x: `${h.hour}:00`, y: h.value }))
  }));

  const options: ApexCharts.ApexOptions = {
    chart: { type: 'heatmap', toolbar: { show: false } },
    dataLabels: { enabled: false },
    xaxis: { type: 'category'},
    plotOptions: {
      heatmap: {
        shadeIntensity: 0.5,
        radius: 0,
        useFillColorAsStroke: true,
      }
    },
    colors: ['#009ef7'],
    tooltip: {
      y: { formatter: val => `${val} visites` }
    }
  };

  return <Chart options={options} series={series} type="heatmap" width={width} height={height} />;
};

export default TrafficHeatmap;
